import { Action } from '@ngrx/store';

export enum ProductArrivalActionTypes {
    LoadByFollow = '[API] Load product arrivals by follow',
    LoadByFollowSuccess = '[API] Load product arrivals by follow success',
    LoadByFollowFail = '[API] Load product arrivals by follow fail',
  
    LoadByProduct = '[API] Load product arrivals by product',
    LoadByProductSuccess = '[API] Load product arrivals by product success',
    LoadByProductFail = '[API] Load product arrivals by product fail',

  }
  
  export class LoadByFollow implements Action {
    readonly type = ProductArrivalActionTypes.LoadByFollow;
    constructor(
      public FollowId: number,
      public CountryId?: number,
      public ProformaId?: number,
      public ProductId?: number
    ) {}
  }
  
  export class LoadByFollowSuccess implements Action {
    readonly type = ProductArrivalActionTypes.LoadByFollowSuccess;
    constructor(public arrivals: any) {}
  }
  
  export class LoadByFollowFail implements Action {
    readonly type = ProductArrivalActionTypes.LoadByFollowFail;
    constructor(public error: any) {}
  }
  
  export class LoadByProduct implements Action {
    readonly type = ProductArrivalActionTypes.LoadByProduct;
    constructor(public ProductId: number) {}
  }
  
  export class LoadByProductSuccess implements Action {
    readonly type = ProductArrivalActionTypes.LoadByProductSuccess;
    constructor(public arrivals: any) {}
  }
  
  export class LoadByProductFail implements Action {
    readonly type = ProductArrivalActionTypes.LoadByProductFail;
    constructor(public error: any) {}
  }
  
  export type ProductArrivalActionsUnion =
    | LoadByFollow
    | LoadByFollowSuccess
    | LoadByFollowFail
    | LoadByProduct
    | LoadByProductSuccess
    | LoadByProductFail
  